import React, { useState, useRef } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { CustomForm, CustomModal } from "../../components";
import {
  useFetchAllNewsNetQuery,
  useFetchAllSportsQuery,
  useCreateNewsNetMutation,
  useUpdateNewsNetMutation,
  useFetchAllNewstypeQuery,
  useDeleteNewsNetMutation,
} from "../../store/api/apiSlice";
import { toast } from "react-toastify";
import { Button as CustomBtn } from "../../ui";

const baseUrl = process.env.REACT_APP_SERVER_URL;
const secretKey = process.env.REACT_APP_SECRET_KEY;
const NewsTop25Management = () => {
  const { data: NewLinkData, refetch } = useFetchAllNewsNetQuery();

  const { data: sportsData } = useFetchAllSportsQuery();
  const sportsList = sportsData?.sports || [];

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [saveButton, setSaveButton] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  const [selectedSport, setSelectedSport] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [resourceURL, setResourceURL] = useState("");
  const [currentNewsId, setCurrentNewsId] = useState("");

  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [viewedNews, setViewedNews] = useState(null);

  const [createNewsNet] = useCreateNewsNetMutation();
  const [updateNewsNet] = useUpdateNewsNetMutation();
  const [deleteNewsNet] = useDeleteNewsNetMutation();

  const handleSportChange = (e) => setSelectedSport(e.target.value);
  const handleTypeChange = (e) => setSelectedType(e.target.value);
  const handleGenderChange = (e) => setSelectedGender(e.target.value);
  const handleResourceURLChange = (e) => setResourceURL(e.target.value);

  const openModal = () => {
    setSaveButton(false);
    setIsEditing(false);
    setModalOpen(true);
  };
  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setIsEditing(false);
    setCurrentNewsId("");

    setSelectedSport("");
    setSelectedGender("");
    setSelectedType("");
    setResourceURL("");
  };

  const paginatedUsers = NewLinkData?.top_net_links?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(
    NewLinkData?.top_net_links?.length / itemsPerPage
  );
  const handleDelete = async (id) => {
    try {
      await deleteNewsNet(id).unwrap();
      toast.success("News deleted successfully");
      refetch();
    } catch (error) {
      toast.error("Error deleting news");
    }
  };
  const handleEdit = (news) => {
    setIsEditing(true);
    setCurrentNewsId(news._id);

    setSelectedSport(news?.sports_name);
    setSelectedGender(news?.gender);
    setSelectedType(news?.type);
    setResourceURL(news?.resource_URL);

    setModalOpen(true);
  };
  const handleSubmit = async (e) => {
    setSaveButton(true);
    e.preventDefault();

    const payload = {
      sports_name: selectedSport || "",
      type: selectedType || "",
      resource_URL: resourceURL || "",
      gender: selectedGender || "",
    };

    try {
      if (isEditing) {
        await updateNewsNet({ id: currentNewsId, newsData: payload }).unwrap();
        setSaveButton(false);
        toast.success("News updated successfully!");
      } else {
        await createNewsNet(payload).unwrap();
        setSaveButton(false);
        toast.success("News created successfully!");
      }
      refetch();
      closeModal();
    } catch (error) {
      if (
        error?.data?.message ===
        "Top Net Link already exists with given type and sports name"
      ) {
        setSaveButton(false);
        toast.error(error.data.message);
      } else {
        setSaveButton(false);
        toast.error("Error saving news");
      }
    }
  };
  const openViewModal = async (id) => {
    const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token || "";
    try {
      const response = await fetch(
        `${baseUrl}/api/top-net-link/get-single/${id}`,
        {
          headers: { "secret-key": secretKey, "x-auth-token": xAuthToken },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setViewedNews(data.top_net_link);
        console.log("data.news", data.top_net_link);
        setViewModalOpen(true);
      } else {
        toast.error("Failed to fetch news details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching news details.");
    }
  };

  const closeViewModal = () => {
    setViewModalOpen(false);
    setViewedNews(null);
  };
  return (
    <div>
      {" "}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <h3>News Link Management</h3>
        <Button onClick={openModal}>Create News Type</Button>
      </div>
      <Table striped bordered hover responsive className="mt-4">
        <thead>
          <tr>
            <th>Type</th>
            <th>Sport Name</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers?.length > 0 ? (
            paginatedUsers?.map((news) => (
              <tr
                key={news._id}
                style={{ cursor: "pointer" }}
                onClick={() => openViewModal(news._id)}
              >
                <td>{news.type}</td>
                <td>{news.sports_name}</td>

                <td>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      className="Update-delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(news);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                      alt="create-new"
                    />

                    <img
                      className="Update-delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(news._id);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                      alt="filled-trash"
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        <div style={{ padding: "1rem", maxHeight: "80vh", overflowY: "auto" }}>
          <h4
            style={{
              fontSize: "1.2rem",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            {isEditing ? "Edit News Type" : "Create News Type"}
          </h4>
          <CustomForm onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label>Sports</Form.Label>
              <Form.Select value={selectedSport} onChange={handleSportChange}>
                <option value="">Select Sports</option>
                {sportsList.map((sport) => (
                  <option key={sport._id} value={sport.name}>
                    {sport.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Resource URL</Form.Label>
              <Form.Control
                value={resourceURL}
                onChange={handleResourceURLChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Select Type</Form.Label>
              <Form.Select
                value={selectedType}
                onChange={handleTypeChange}
                placeholder="Type"
                name="Type"
              >
                <option value="">Select Type</option>
                <option value="top25">Top 25</option>
                <option value="net">Net</option>
              </Form.Select>
            </Form.Group>
            <Form.Group>
              <Form.Label>Select Gender</Form.Label>
              <Form.Select
                value={selectedGender}
                onChange={handleGenderChange}
                placeholder="Select Gender"
                name="Select Gender"
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="">Other</option>
              </Form.Select>
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={closeModal} className="me-2">
                Cancel
              </Button>
              <CustomBtn loading={saveButton} variant="primary" type="submit">
                {isEditing ? "Update" : "Save"}
              </CustomBtn>
            </div>
          </CustomForm>
        </div>
      </CustomModal>
      <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
        <div
          style={{
            maxWidth: "600px",
            padding: "20px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <h3>News Link Details</h3>

          <p>
            <strong>Sport:</strong> {viewedNews?.sports_name}
          </p>
          <p>
            <strong>News Type:</strong> {viewedNews?.type}
          </p>

          <p>
            <strong>Resource URL:</strong> {viewedNews?.resource_URL}
          </p>
        </div>
      </CustomModal>
    </div>
  );
};

export default NewsTop25Management;
